var US_STATES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado',
  'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho',
  'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana',
  'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota',
  'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada',
  'New Hampshire', 'New Jersey', 'New Mexico', 'New York',
  'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon',
  'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
  'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington',
  'West Virginia', 'Wisconsin', 'Wyoming'
];

document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('wholesale-register-form');
  if (!form) return;

  populateUSStates();

  if (form.dataset.formType === 'new') {
    initNewCustomerForm();
  } else {
    initExistingCustomerForm();
    checkPendingAddress();
  }
});

function populateUSStates() {
  var select = document.getElementById('wholesale-province');
  if (!select) return;
  select.innerHTML = '<option value="">Select state</option>';
  US_STATES.forEach(function (s) {
    var opt = document.createElement('option');
    opt.value = s;
    opt.textContent = s;
    select.appendChild(opt);
  });
}

// ─── NEW CUSTOMER ────────────────────────────────────────────────────────────

function initNewCustomerForm() {
  var form = document.getElementById('wholesale-register-form');
  if (!form) return;

  form.addEventListener('submit', function () {
    var pending = {
      address1: getVal('wholesale-address1'),
      address2: getVal('wholesale-address2'),
      zip:      getVal('wholesale-zip'),
      city:     getVal('wholesale-city'),
      province: getVal('wholesale-province'),
      company:  getVal('wholesale-company'),
      website:  getVal('wholesale-website'),
      rrss:     getVal('wholesale-rrss')
    };
    sessionStorage.setItem('wholesale_pending_address', JSON.stringify(pending));

    var noteField = document.getElementById('wholesale-customer-note');
    if (noteField) {
      var lines = ['--- WHOLESALE APPLICATION ---'];
      var map = {
        'Company Name':      pending.company,
        'Website':           pending.website,
        'RRSS':              pending.rrss,
        'Street Address':    pending.address1,
        'Street Address 2':  pending.address2,
        'Zip / Postal Code': pending.zip,
        'City':              pending.city,
        'State':             pending.province,
        'Country':           'United States'
      };
      for (var k in map) {
        if (map[k]) lines.push(k + ': ' + map[k]);
      }
      lines.push('--- END WHOLESALE APPLICATION ---');
      noteField.value = lines.join('\n');
    }
  });
}

// ─── EXISTING CUSTOMER (manual submit) ───────────────────────────────────────

function initExistingCustomerForm() {
  var form = document.getElementById('wholesale-register-form');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Submitting\u2026';
    }
    submitExistingCustomerData();
  });
}

// ─── AUTO-SUBMIT after new-customer redirect ──────────────────────────────────

function checkPendingAddress() {
  var raw = sessionStorage.getItem('wholesale_pending_address');
  if (!raw) return;

  var form = document.getElementById('wholesale-register-form');
  if (!form || form.dataset.formType !== 'existing') return;

  var data;
  try {
    data = JSON.parse(raw);
  } catch (e) {
    sessionStorage.removeItem('wholesale_pending_address');
    return;
  }
  sessionStorage.removeItem('wholesale_pending_address');

  // Show loading banner
  var wrapper = document.querySelector('.m-wholesale-register__wrapper');
  if (wrapper) {
    var banner = document.createElement('p');
    banner.style.cssText = 'padding:12px 0;color:#555;font-size:14px;';
    banner.textContent = 'Saving your billing address\u2026';
    wrapper.insertBefore(banner, wrapper.firstChild);
  }

  // Populate visible fields so submitExistingCustomerData can read them
  setVal('wholesale-address1', data.address1);
  setVal('wholesale-address2', data.address2);
  setVal('wholesale-zip',      data.zip);
  setVal('wholesale-city',     data.city);
  setVal('wholesale-company',  data.company);
  setVal('wholesale-website',  data.website);
  setVal('wholesale-rrss',     data.rrss);

  var provinceSelect = document.getElementById('wholesale-province');
  if (provinceSelect && data.province) {
    provinceSelect.value = data.province;
  }

  // Submit directly — no form dispatch, no redirect
  submitExistingCustomerData();
}

// ─── CORE SUBMISSION ──────────────────────────────────────────────────────────

function submitExistingCustomerData() {
  // 1. Build address payload from visible fields + hidden form tokens
  var addressForm = document.getElementById('wholesale-address-form');
  var addrData = new FormData();

  // Copy tokens from the Shopify customer_address form (CSRF etc.)
  if (addressForm) {
    ['form_type', 'utf8', 'authenticity_token', '_method'].forEach(function (n) {
      var el = addressForm.querySelector('[name="' + n + '"]');
      if (el) addrData.append(n, el.value);
    });
    // Customer name from hidden form pre-fills
    var fn = addressForm.querySelector('[name="address[first_name]"]');
    var ln = addressForm.querySelector('[name="address[last_name]"]');
    if (fn) addrData.append('address[first_name]', fn.value);
    if (ln) addrData.append('address[last_name]', ln.value);
  }

  addrData.append('address[address1]', getVal('wholesale-address1'));
  addrData.append('address[address2]', getVal('wholesale-address2'));
  addrData.append('address[zip]',      getVal('wholesale-zip'));
  addrData.append('address[city]',     getVal('wholesale-city'));
  addrData.append('address[province]', getVal('wholesale-province'));
  addrData.append('address[company]',  getVal('wholesale-company'));
  addrData.append('address[country]',  'United States');
  addrData.append('address[default]',  '1');

  // 2. Build contact email body
  var visibleForm = document.getElementById('wholesale-register-form');
  var visibleFormData = new FormData(visibleForm);

  var contactData = new FormData();
  contactData.append('form_type', 'contact');
  contactData.append('utf8', '\u2713');
  contactData.append('contact[email]', visibleFormData.get('contact[email]') || '');
  contactData.append('contact[body]', buildContactBody());

  var fetchMarketing = getMarketingOptInValue()
    ? fetch('/account', {
        method: 'POST',
        body: buildMarketingData(addressForm),
        credentials: 'same-origin'
      })
    : Promise.resolve();

  // 3. Fire all requests — no redirect, we control what happens next
  var fetchAddr = addressForm
    ? fetch('/account/addresses', {
        method: 'POST',
        body: addrData,
        credentials: 'same-origin'
      })
    : Promise.resolve();

  var fetchContact = fetch('/contact', {
    method: 'POST',
    body: contactData,
    headers: { 'Accept': 'application/json' }
  });

  Promise.all([fetchAddr, fetchContact, fetchMarketing])
    .then(showSuccess)
    .catch(showSuccess);
}

function getMarketingOptInValue() {
  var checkbox = document.getElementById('wholesale-accepts-marketing');
  return checkbox && checkbox.checked ? '1' : '';
}

function buildMarketingData(addressForm) {
  var marketingData = new FormData();
  marketingData.append('form_type', 'customer');
  marketingData.append('utf8', '\u2713');
  marketingData.append('customer[accepts_marketing]', '1');

  if (addressForm) {
    ['authenticity_token', 'utf8'].forEach(function (n) {
      var el = addressForm.querySelector('[name="' + n + '"]');
      if (el) marketingData.append(n, el.value);
    });
  }

  return marketingData;
}

function buildContactBody() {
  var lines = ['WHOLESALE APPLICATION', 'Tag to add: wholesale_register', ''];
  var map = [
    ['Street Address',    'wholesale-address1'],
    ['Street Address 2',  'wholesale-address2'],
    ['Zip / Postal Code', 'wholesale-zip'],
    ['City',              'wholesale-city'],
    ['State',             'wholesale-province'],
    ['Country',           null],           // always United States
    ['Company Name',      'wholesale-company'],
    ['Website',           'wholesale-website'],
    ['RRSS',              'wholesale-rrss']
  ];
  map.forEach(function (row) {
    var val = row[1] ? getVal(row[1]) : 'United States';
    if (val) lines.push(row[0] + ': ' + val);
  });

  if (getMarketingOptInValue()) {
    lines.push('Marketing opt-in: Sí');
  }

  return lines.join('\n');
}

// ─── UTILS ────────────────────────────────────────────────────────────────────

function getVal(id) {
  var el = document.getElementById(id);
  return el ? el.value.trim() : '';
}

function setVal(id, val) {
  var el = document.getElementById(id);
  if (el && val) el.value = val;
}

function showSuccess() {
  var wrapper = document.querySelector('.m-wholesale-register__wrapper');
  if (wrapper) {
    wrapper.innerHTML =
      '<div class="m-wholesale-register__success">' +
      '<h2>Application Submitted!</h2>' +
      '<p>Thank you for your wholesale application. We will review your information and get back to you soon.</p>' +
      '<a href="/" class="m-button m-button--primary">Back to Store</a>' +
      '</div>';
  }
}
